import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-dangerous-permissions',
  templateUrl: './app-dangerous-permissions.html',
  styleUrls: ['./app-dangerous-permissions.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppDangerousPermissions implements OnInit, OnChanges {
  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() month;
  @Input() isFreemium: boolean;
  @Input() isFollowing: boolean;
  @Output() anchorClick = new EventEmitter<string>();
  @Output() followClick = new EventEmitter<boolean>();

  allPermissions: any;
  showDangerous = true;
  tooltipTemplate =
    '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner email"></div></div>';
  hasDangerousPermissions: boolean;
  googleProtectionTooltip: string =
    '<p>' +
    '<div>Normal permissions</div>' +
    "<div>Normal permissions cover areas where your app needs to access data or resources outside the app's sandbox, but where there's very little risk to the user's privacy or the operation of other apps. For example, permission to set the time zone is a normal permission.</div>" +
    '</p>' +
    '<p>' +
    "If an app declares in its manifest that it needs a normal permission, the system automatically grants the app that permission at install time. The system doesn't prompt the user to grant normal permissions, and users cannot revoke these permissions." +
    '</p>' +
    '<p>' +
    '<div>Dangerous permissions</div>' +
    "<div>Dangerous permissions cover areas where the app wants data or resources that involve the user's private information, or could potentially affect the user's stored data or the operation of other apps. For example, the ability to read the user's contacts is a dangerous permission. If an app declares that it needs a dangerous permission, the user has to explicitly grant the permission to the app. Until the user approves the permission, the app cannot provide functionality that depends on that permission.</div>" +
    '</p>' +
    '<p>' +
    'To use a dangerous permission, an app must prompt the user to grant permission at runtime.' +
    '</p>';
  googleProtectionTooltipTpl =
    '<div class="tooltip tooltip-google-protection" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>';

  deviceTypes = [
    {
      name: 'smartphone',
      tooltip:
        'Combined advertiser risk for the App on Smartphones by business region'
    },
    {
      name: 'tablet',
      tooltip:
        'Combined advertiser risk for the App on Tablets by business region'
    }
  ];

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      const dangerousPermissions = this.data['permissions']['all'].filter(
        permission => {
          let effects = permission.effects || [];
          return permission.isDangerous || effects.indexOf('Privacy') >= 0;
        }
      );
      this.hasDangerousPermissions = dangerousPermissions.length > 0;
      if (this.hasDangerousPermissions) {
        this.showDangerousClick(true);
      } else {
        this.showDangerousClick(false);
      }
    }
  }

  showDangerousClick(showDangerous: boolean) {
    this.showDangerous = showDangerous;

    if (this.showDangerous) {
      this.allPermissions = this.data['permissions']['all'].filter(
        permission => {
          let effects = permission.effects || [];
          return permission.isDangerous || effects.indexOf('Privacy') >= 0;
        }
      );
    } else {
      this.allPermissions = this.data['permissions']['all'];

      // setTimeout(() => {
      //   jQuery('*[data-toggle="tooltip"]').tooltip({html: true});
      // }, 300);
    }
  }

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }

  follow(): void {
    this.followClick.emit(true);
  }
}
